export const environment = {
	production: false,
	backendUrl: 'https://api.platform.webout.dev',
	// Authenticated API. Relative, not `backendUrl`: served from this app's own
	// origin (CloudFront `/api/*` in prod, dev-server proxy locally) so the auth
	// refresh cookie is first-party. `backendUrl` stays absolute for the player,
	// /preview, /media and published projects.
	apiUrl: 'https://api.platform.webout.dev',
	// Base of the shareable personalized-video link (DEV-573). Points at the
	// public web page that consumes the link, NOT at this backend — the backend
	// only serves the raw variables behind `GET /preview/:uuid`.
	personalizedLinkBaseUrl: 'https://webout.com/preview',
	weboutRegion: 'AWS' as const,
	maxUploadSizeMb: 500,
	primeuiLicenseKey: 'eyJpZCI6ImMzNjM1OTBjLTg2MTctNGJhMy04ZmNlLTgyMDM5NmYzMzRjYiIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3ODI4MTc1MjAsImV4cCI6MTgxNDM1MzUyMH0.4VxCq8LgcZRboRKCdBnJ-rv7jxzNmTmSjnRyfeLmlupURNqHHsC7N7U23LxB5nSHkzI-CzTyy6F8pgpzMCWmAA',
	sentryDsn: 'https://dfa961f3e19d153acce2c58ab19b6d29@o4508575744393216.ingest.de.sentry.io/4511780498571344',
	sentryEnvironment: 'development',
};
